import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Divider, Modal, Typography } from 'antd';
import { Footer as AntdFooter } from 'antd/es/layout/layout';

import Logo from '@/components/shared/Logo';
import { openInNewTab } from '@/helpers';
import { COOKIES_URL, PRIVACY_URL, TERMS_URL, V3_URL } from '@/settings';
import styled, { css, StyledProp } from '@/styled';

const Footer = (props: StyledProp) => {
  const navigate = useNavigate();

  const [modalCreateCourse, setModalCreateCourse] = useState(false);

  const handleCreateCourseModal = () => {
    setModalCreateCourse(!modalCreateCourse);
  };

  const redirectToProducerWizard = () => {
    window.open(`${V3_URL}/cursos/wizard`, '_blank');
    handleCreateCourseModal();
  };

  return (
    <AntdFooter {...props}>
      <Divider type='horizontal' className='divider' />
      <div className='footer-container'>
        <Logo />
        <Divider type='vertical' className='divider' />
        <Typography.Text>A ÁREA DE MEMBROS DA EDUZZ</Typography.Text>
        <div className='links'>
          <Typography.Link onClick={() => openInNewTab(PRIVACY_URL)}>Privacidade</Typography.Link>
          <Typography.Link onClick={() => openInNewTab(TERMS_URL)}>Termos e Condições</Typography.Link>
          <Typography.Link onClick={() => openInNewTab(COOKIES_URL)}>Cookies</Typography.Link>
          <Typography.Link onClick={() => navigate('ajuda')}>Ajuda</Typography.Link>
        </div>
      </div>

      <Modal
        title='Gostaria de criar um curso?'
        open={modalCreateCourse}
        onCancel={handleCreateCourseModal}
        onOk={redirectToProducerWizard}
        okText='Aceitar'
        cancelText='Cancelar'
      >
        <Typography.Text>
          Após completar essa ação você se tornará produtor, poderá criar cursos e seu perfil de aluno não será
          alterado. Você poderá acessar tanto o ambiente de aluno como o de produtor.
        </Typography.Text>
      </Modal>
    </AntdFooter>
  );
};

export default styled(Footer)(
  ({ theme }) => css`
    margin-top: ${theme.space.spacing(20)};
    padding: ${theme.space.spacing(0, 16)};
    transition: ${theme.motionDurationMid};

    > .divider {
      border-color: ${theme.variables.dividerColor};
      margin: 0;
    }

    ${theme.breakpoints.down('md')} {
      padding: ${theme.space.spacing(0, 0)};
    }

    .footer-container {
      min-height: 80px;
      display: grid;
      padding: ${theme.space.spacing(6, 0)};
      align-items: center;
      grid-template-columns: 116px 24px 241px auto;

      svg {
        width: 95px;
      }

      > .divider {
        height: 24px;
        margin: 0;
        border-color: ${theme.variables.dividerColor};
      }

      > span {
        color: ${theme.colorTextTertiary};
      }

      > .links {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
        column-gap: ${theme.space.spacing(6)};

        > a {
          word-break: normal;
          white-space: nowrap;
          color: ${theme.colorTextTertiary};
        }
      }

      ${theme.breakpoints.down('md')} {
        grid-template-columns: none;
        grid-template-rows: auto 40px auto;
        padding: ${theme.space.spacing(6, 4)};
        > .divider {
          display: none;
        }

        > span,
        img {
          margin: auto;
        }

        > .links {
          column-gap: ${theme.space.spacing(4)};
          justify-content: center;
        }
      }
    }
  `
);
